import { Injectable } from '@angular/core';

import { LativHttpClient } from '@service/lativ.interceptor';
import {
  ListSearchKeywordsResponse,
  SearchProductsRequest,
  SearchProductsResponse,
} from '@proto/store/api/store/search';

import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchRepositoryService {
  constructor(private http: LativHttpClient) {}

  listSearchKeywords(): Observable<ListSearchKeywordsResponse> {
    return this.http.get('v1/search/keywords').pipe(map(res => ListSearchKeywordsResponse.fromJSON(res)));
  }

  searchProducts(req: SearchProductsRequest): Observable<SearchProductsResponse> {
    return this.http
      .get('v1/search/products', {
        params: SearchProductsRequest.toJSON(req) as {
          [param: string]: string;
        },
      })
      .pipe(map(res => SearchProductsResponse.fromJSON(res)));
  }
}
